import ModelMappingOrigin from "~/models/mapping/modelMappingOrigin";
import PaymentStep from "../../../formability/form_builder/models/workflow/paymentStep";
import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import {PaymentProperty, PaymentPropertyType} from "~/enums/paymentPropertyType";
import {PaymentInformationType} from "../../../formability/mappingBuilder/enums/payment-information-type";
import {PaymentType} from "../../enums/workflow/paymentType";
import ModelMappingValueOriginPaymentStep from "~/models/mapping/modelMappingValueOriginPaymentStep";
import {IOriginWrapper} from "~/interfaces/mappingInterfaces";
import OriginWrapperPaymentStepLineItem from "~/models/mapping/originWrapperPaymentStepLineItem";

interface IValue {
  label_title: string
  client_id: string
  labelSuffix: string
  section?: string
}

// When Form Payment Step is the origin
export default class ModelMappingOriginPaymentStep extends ModelMappingOrigin<PaymentStep> {
  isSingle = true

  get origin(): PaymentStep {
    return PaymentStep.repo.find(this.id);
  }

  get identifier(): string {
    return this.origin?.client_id
  }

  get title(): string {
    return this.origin?.titleOrDefault
  }

  get values(): IValue[] {
    const values: IValue[] = []
    if (!this.origin) return values
    const buildValue = (type: PaymentInformationType) => {
      return {
        client_id: ModelMappingValueOriginPaymentStep.buildId(this.origin, type),
        label_title: ModelMappingValueOriginPaymentStep.buildLabel(this.origin, type),
        labelSuffix: `(${ModelMappingValueOriginPaymentStep.buildLabelSuffix(this.origin, type)})`,
      }
    }

    values.push(
      buildValue(PaymentInformationType.StepCompleterName),
      buildValue(PaymentInformationType.TotalPaidFor),
    )

    if (this.origin.payment_type !== PaymentType.check) {
      values.push(buildValue(PaymentInformationType.ReceiptNumberFor))
    }

    return values
  }

  searchValues(query?: string, options: { filters?: ((value: string) => boolean)[], showUnmappedOnly?: boolean } = {}): Partial<this['values']> {
    const filters = [
      value => value.label_title?.toLowerCase().trim().includes(query?.toLowerCase().trim())
    ]
    if (options.showUnmappedOnly) {
      filters.unshift(value => {
        return !this.modelMapping.isMapped(value.client_id)
      })
    }
    return this.values.filter(value => filters.every(f => f(value)))
  }

  valueOptions(source: ModelMappingValueOrigin = null): IDefaultVOption[] {
    const values: IDefaultVOption[] = []
    values.push({
      label: 'Amount',
      value: PaymentProperty.Amount,
      labelSuffix: PaymentPropertyType[PaymentProperty.Amount]
    })
    return values
  }

  /**
   * PaymentStep model mapping origin has not uploader value options
   */
  uploaderValueOptions: IDefaultVOption[] = []

  /**
   * Take results from the values search and format them as a-select options
   * @param value
   */
  mapValueToOption(value: IValue): IDefaultVOption {
    return {
      label: value.label_title,
      value: value.client_id,
      labelSuffix: value.labelSuffix,
      section: value.section,
    }
  }

  // ******************** NESTED MODEL MAPPING ******************** //
  /**
   * the payment step is its own relationship model as it is the source
   * for the line items
   */
  get relationshipModels(): PaymentStep[] {
    return [this.origin]
  }

  nestedModelMappingSourceOptions(): IOriginWrapper[] {
    return this.relationshipModels.map(step => new OriginWrapperPaymentStepLineItem(step))
  }

  // ******************** NESTED MODEL MAPPING END ******************** //
}